import React from 'react';
import PropTypes from 'prop-types';

export const Table = ({ info }) => {
  const tableStyles = {
    borderCollapse: 'collapse',
    boxShadow: '0 5px 10px #e1e5ee',
    backgroundColor: 'white',
    textAlign: 'left',
    overflow: 'hidden',
    width: '100%',
  };

  const rowStyles = {
    backgroundColor: '#f4f6fb',
  };

  const thTdStyles = {
    padding: '1rem 2rem',
  };
  return (
    <div>
      <br />
      <table style={tableStyles}>
        <tbody>
          <tr>
            <th style={thTdStyles} scope="row">
              Full Name
            </th>
            <td style={thTdStyles}>{info.name}</td>
          </tr>
          <tr style={rowStyles}>
            <th style={thTdStyles} scope="row">
              Job Title
            </th>
            <td style={thTdStyles}>{info.title}</td>
          </tr>
          <tr>
            <th style={thTdStyles} scope="row">
              Email Address
            </th>
            <td style={thTdStyles}>{info.email}</td>
          </tr>
          <tr style={rowStyles}>
            <th style={thTdStyles} scope="row">
              Phone Number
            </th>
            <td style={thTdStyles}>{info.phone}</td>
          </tr>
          <tr>
            <th style={thTdStyles} scope="row">
              Preferred mode of contact
            </th>
            <td style={thTdStyles}>{info.contact}</td>
          </tr>
          <tr style={rowStyles}>
            <th style={thTdStyles} scope="row">
              Have you submitted a claim?
            </th>
            <td style={thTdStyles}>{info.claimSubmitted}</td>
          </tr>
          {info.claimSubmitted === 'Yes' && (
            <tr>
              <th style={thTdStyles} scope="row">
                Date the claim was submitted
              </th>
              <td style={thTdStyles}>
                {String(info.claimDate).replaceAll('/', '-')}
              </td>
            </tr>
          )}
          {info.aarpToggle && (
            <tr style={rowStyles}>
              <th style={thTdStyles} scope="row">
                AARP Health Plan coverage{' '}
              </th>
              <td style={thTdStyles}>{info.healthProgram}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  info: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    contact: PropTypes.string,
    claimSubmitted: PropTypes.string,
    claimDate: PropTypes.string,
    aarpToggle: PropTypes.bool,
    healthProgram: PropTypes.string,
  }).isRequired,
};
